import {Component, OnInit} from '@angular/core';
import {PacientService} from '../../../services/pacient.service';
import {LoadingController} from '@ionic/angular';

@Component({
    selector: 'app-atendimento-internacao-component',
    templateUrl: 'atendimento-internacao-component.html',
    styleUrls: ['./atendimento-internacao-component.scss']
})

export class AtendimentoInternacaoComponent implements OnInit {

    page = 'list'
    atendimentoSelecionado: any;

    constructor(
        private pacient: PacientService,
        private loadingCtrl: LoadingController,
    ) {
    }

    ngOnInit() {

    }

    async loadData(event) {

    }

    async listarAtendimentos() {
        this.page = 'list';
        this.atendimentoSelecionado = '';
    }


    async detalharAtendimento(atendimento) {
        this.page = 'detail';
        this.atendimentoSelecionado = atendimento;
    }
}
